/* eslint-disable import/no-unresolved */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAppViewerModuleTempDashboardUrl } from '@components/common/Dashboard/utils/getTempDashboardUrl';
import { createTempDashboard } from '@store/tempDashboard/actions';
import { Provider } from 'jotai';
import { filterSelector } from '@store/common/selectors';
import { useParams, useHistory } from 'react-router-dom';
import { ErrorBoundary, PageTitle } from '@components/common';
import { selector as commonSelector } from '@store/common';
import RetryContext from '@src/contexts/retryContext';
import DashboardTabs from '@components/common/Dashboard/DashboardTabs';
import EmpSankeyPage from '@components/common/EmpWidget/EmpSankeyPage';
import { buildDashboardStore } from '@src/atoms/utils';
import { APP_SANKEY_KEY, DASHBOARD_TYPE } from '@utils/constants';
import { get } from 'lodash';
import sankeyStore from '@src/globalStore/sankeyStore';
import { updateWidgetProps } from '@components/common/EmpWidget/EMPWidgetContainer';
import ReleaseVersion from '@components/common/ReleaseVersion';

const defaultStore = buildDashboardStore();
const { baseUrl } = window.conviva;

export const useGoToUserTimeline = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const setClientIdForTempDashbords = sankeyStore((state) => state.setClientIdForTempDashbords);
  const clientIdForTempDashbords = sankeyStore((state) => state.clientIdForTempDashbords);
  const handleEvent: any = (event, props) => {
    event.preventDefault();
    const { userId, clientId, type = 'user', interval } = props;
    const id = type === 'user' ? userId : clientId;
    if (userId || clientId) {
      // callback to push new temp tab url
      const redirectHandler = ({ id }) => {
        setClientIdForTempDashbords({ ...clientIdForTempDashbords, [id]: clientId });
        history.push(getAppViewerModuleTempDashboardUrl({ viewerId: userId, clientId }, id));
      };
      const title = type === 'user' ? 'User' : 'Client';

      // create local storage entry
      dispatch(
        createTempDashboard(
          DASHBOARD_TYPE.APP_VIEWER_MODULE,
          { viewerId: userId, clientId, interval, source: 'emp' },
          `${title} - ${id}`,
          { redirectHandler },
        ),
      );
    }
  };
  return handleEvent;
};

function Sankey(props) {
  // const [showModal, setShowModal] = React.useState(false);
  const { match, store = defaultStore } = props;
  const history = useHistory();
  const globalFilter = useSelector(filterSelector);
  const { id: eventName }: any = useParams();
  const { interval } = useSelector(commonSelector);
  const onGoToUserTimeline = useGoToUserTimeline();
  const id = get(match, 'params.id', APP_SANKEY_KEY); // default home page is trends
  const setFunnel = sankeyStore((state) => state.setInitFunnelPayload);

  const onConvertToFunnel = (value) => {
    setFunnel(value);
    history.push(`${baseUrl}/dashboard/funnel`, { from: 'sankey' });
  };

  return (
    <Provider store={store}>
      <>
        <RetryContext.Provider value={{ interval }}>
          <ErrorBoundary>
            <DashboardTabs id={id} />
            <PageTitle text="Sankey" />
            <ReleaseVersion type={'Beta'} style={{ insetInlineEnd: 0, top: 0 }} />
            <EmpSankeyPage
              interval={interval}
              globalFilter={globalFilter}
              eventName={eventName}
              onModalClose={() => {
                // go to previous page
                history.goBack();
                updateWidgetProps({
                  widgetName: '',
                  open: false,
                });
              }}
              onConvertToFunnel={onConvertToFunnel}
              onGoToUserTimeline={onGoToUserTimeline}
            />
            {/* <Footer /> */}
          </ErrorBoundary>
        </RetryContext.Provider>
      </>
    </Provider>
  );
}

export default Sankey;
